import { Users } from 'lucide-react';
import { useEmployeeNameFormatter } from '@/lib/employee-name';
import { useTeamTodayManager } from '@/hooks/use-dashboard';
import { WidgetCard } from '../widget-card';
import { TeamTodayList } from './team-today-list';
import { asArray } from '../widget-format';

/**
 * `teamTodayManager` widget — the signed-in manager's direct reports on leave
 * today. View only; each row links to the person's profile.
 */
export function TeamTodayManagerWidget() {
  const { data, isLoading, isError } = useTeamTodayManager();
  const formatName = useEmployeeNameFormatter();

  // Sort by the displayed name so ordering honors the Name Display setting (as whosOutToday).
  const sorted = data
    ? [...asArray(data)].sort((a, b) => formatName(a).localeCompare(formatName(b)))
    : undefined;

  return (
    <WidgetCard title="My Team Today" icon={Users}>
      <TeamTodayList data={sorted} isLoading={isLoading} isError={isError} />
    </WidgetCard>
  );
}
